import { Howler } from 'howler'

// Disable Howler's 30-second idle auto-suspend of the shared Web Audio context.
// When the context suspends and later resumes, buffer sources that were
// scheduled while it was suspended replay on resume — which surfaced as a
// stale/duplicate voice-over (e.g. "no more bets") and a stale crash-bust thump
// when a tab was backgrounded then refocused, or simply after a quiet stretch.
// We drop time-sensitive cues explicitly at the playback layer instead, so the
// context must never silently suspend under us. Side-effect module: importing
// it anywhere runs this once (Howler is a global singleton).
Howler.autoSuspend = false

// Disarm howler's legacy Mobile-Safari sample-rate workaround. On the first
// new Howl(), _unlockAudio sees ctx.sampleRate !== 44100 (48000 on modern
// hardware) and calls Howler.unload(): ctx.close() + an immediate replacement
// AudioContext. Safari can hand back a context whose currentTime is non-finite,
// and howler's very next masterGain setValueAtTime() then throws
// "TypeError: The provided value is non-finite" — inside module evaluation,
// which rejects the chunk import and kills hydration (the audio subsystem took
// down the whole page). _mobileUnloaded is the branch's own run-once flag;
// pre-setting it makes the unload unreachable. Playback is unaffected — Web
// Audio resamples buffers to whatever rate the context runs at.
// (howler 2.2.4, goldfire/howler.js#1729)
;(Howler as unknown as { _mobileUnloaded: boolean })._mobileUnloaded = true

export {}
